import { bound } from "@frui.ts/helpers";
import { computed, observable } from "mobx";
import { appVersion } from "../config";
import type NewVersionRepository from "../repositories/newVersionRepository";
import { isLocalhost } from "../utils/featureToogle";
import type LocalizationService from "./localizationService";
import type NotificationService from "./notificationService";
import { NotificationType } from "./notificationService";

export default class NewVersionService {
  static CHECK_INTERVAL = 15;
  private version?: string = appVersion;
  @observable private newVersion = false;

  constructor(
    private repository: NewVersionRepository,
    private notificationService: NotificationService,
    private localizationService: LocalizationService
  ) {}

  @bound
  async initialize() {
    // Do not check new version on localhost environemnt
    if (isLocalhost()) {
      return;
    }

    try {
      const latestVersion = (await this.repository.getVersion()).version;
      if (this.version && latestVersion !== this.version) {
        this.newVersion = true;
        this.notificationService.add({
          type: NotificationType.WARNING,
          title: this.localizationService.translateGeneral("newVersionAvailable.title"),
          permanent: true,
          closable: true,
          action: {
            title: this.localizationService.translateGeneral("newVersionAvailable.update"),
            func: this.updateAppIfNewVersionIsAvailable,
          },
        });
      } else {
        this.version = latestVersion;
        setTimeout(() => void this.initialize(), NewVersionService.CHECK_INTERVAL * 60 * 1000);
      }
    } catch (e) {
      setTimeout(() => void this.initialize(), NewVersionService.CHECK_INTERVAL * 60 * 1000);
    }
  }

  @computed
  get newVersionAvailable() {
    return this.newVersion;
  }

  @bound
  updateAppIfNewVersionIsAvailable() {
    if (this.newVersion) {
      window.location.reload();
    }
  }
}
